"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleRetentionControlTexts = void 0;
require("../../../core");
require("../types");
const getScheduleRetentionControlTexts = (t) => {
    return {
        days: t('scheduleControl|retentionType|days'),
        months: t('scheduleControl|retentionType|months'),
        years: t('scheduleControl|retentionType|years'),
    };
};
exports.getScheduleRetentionControlTexts = getScheduleRetentionControlTexts;
//# sourceMappingURL=getScheduleRetentionControlTexts.js.map